var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoQuickDownloadNormal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "r44ktfl5ha"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.286 3.429h8.071l5.357 5.357v9.785a2 2 0 0 1-2 2H6.286a2 2 0 0 1-2-2V5.43a2 2 0 0 1 2-2z",
    fill: "#508EF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.357 3.429v4.357a1 1 0 0 0 1 1h4.357l-5.357-5.357z",
    fill: "#ABD1FC"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395BBB",
    d: "M19.714 10.929V8.786H15.43z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#r44ktfl5ha)",
    strokeLinecap: "round",
    transform: "translate(4.286 3.429)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#B6BFCE",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.538 14.455V7.961"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m7.703 12.29-2.165 2.165-2.164-2.165"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoQuickDownloadNormal);
export default __webpack_public_path__ + "static/media/ico-quick-download-normal.da558b848efa1d2a749cb1a3fb2e074c.svg";
export { ForwardRef as ReactComponent };